import * as constants from "../constants";


export const eventTypes = [
    { key: "LEISURE", value: "LEISURE", text: constants.LEISURE_MEAL_TEXT },
    { key: "PROFESSIONAL", value: "PROFESSIONAL", text: constants.PROFESSIONAL_MEAL_TEXT },
    { key: "FAST", value: "FAST", text: constants.FAST_MEAL_TEXT },
    { key: "BIRTHDAY", value: "BIRTHDAY", text: constants.BIRTHDAY_MEAL_TEXT },
    { key: "SPECIAL", value: "SPECIAL", text: constants.SPECIAL_MEAL_TEXT },
    { key: "OTHER", value: "OTHER", text: constants.OTHER_MEAL_TEXT },
];

export const durationList = [
    {key: "01h00", text: "01" + constants.HOUR_SHORT_TEXT + "00", value: "01:00:00"},
    {key: "01h30", text: "01" + constants.HOUR_SHORT_TEXT + "30", value: "01:30:00"},
    {key: "02h00", text: "02" + constants.HOUR_SHORT_TEXT + "00", value: "02:00:00"},
    {key: "02h30", text: "02" + constants.HOUR_SHORT_TEXT + "30", value: "02:30:00"},
    {key: "03h00", text: "03" + constants.HOUR_SHORT_TEXT + "00", value: "03:00:00"},
    {key: "03h30", text: "03" + constants.HOUR_SHORT_TEXT + "30", value: "03:30:00"},
    {key: "04h00", text: "04" + constants.HOUR_SHORT_TEXT + "00", value: "04:00:00"},
    {key: "04h30", text: "04" + constants.HOUR_SHORT_TEXT + "30", value: "04:30:00"},
    {key: "05h00", text: "05" + constants.HOUR_SHORT_TEXT + "00", value: "05:00:00"},
    {key: "05h30", text: "05" + constants.HOUR_SHORT_TEXT + "30", value: "05:30:00"},
    {key: "06h00", text: "06" + constants.HOUR_SHORT_TEXT + "00", value: "06:00:00"},
];

export const cakeBeforeDurationList = [
    {key: "1 jour", text: "1 " + constants.DAY_TEXT, value: "1 00:00:00"},
    {key: "2 jours", text: "2 " + constants.DAYS_TEXT, value: "2 00:00:00"},
    {key: "3 jours", text: "3 " + constants.DAYS_TEXT, value: "3 00:00:00"},
    {key: "4 jours", text: "4 " + constants.DAYS_TEXT, value: "4 00:00:00"},
    {key: "5 jours", text: "5 " + constants.DAYS_TEXT, value: "5 00:00:00"},
    {key: "6 jours", text: "6 " + constants.DAYS_TEXT, value: "6 00:00:00"},
];

export const reservationBeforeDurationList = [
    {key: "0 minutes", text: "0 minutes", value: "00:00:00"},
    {key: "5 minutes", text: "5 minutes", value: "00:05:00"},
    {key: "15 minutes", text: "15 " + constants.MINUTES_TEXT, value: "00:15:00"},
    {key: "30 minutes", text: "30 " + constants.MINUTES_TEXT, value: "00:30:00"},
    {key: "1 heure", text: "1 " + constants.HOUR_TEXT, value: "01:00:00"},
    {key: "2 heures", text: "2 " + constants.HOURS_TEXT, value: "02:00:00"},
    {key: "3 heures", text: "3 " + constants.HOURS_TEXT, value: "03:00:00"},
    {key: "6 heures", text: "6 " + constants.HOURS_TEXT, value: "06:00:00"},
    {key: "12 heures", text: "12 " + constants.HOURS_TEXT, value: "12:00:00"},
    {key: "1 jour", text: "1 " + constants.DAY_TEXT, value: "1 00:00:00"},
    {key: "2 jours", text: "2 " + constants.DAYS_TEXT, value: "2 00:00:00"},
];

export const cancelledByList = [
    { key: "CANCELLED_BY_RESTAURANT", value: "CANCELLED_BY_RESTAURANT", text: constants.YOUR_RESTAURANT_TEXT },
    { key: "CANCELLED_BY_CUSTOMER", value: "CANCELLED_BY_CUSTOMER", text: constants.THE_CUSTOMER_TEXT },
];

export const weekDays = [
    constants.MONDAY_TEXT,
    constants.TUESDAY_TEXT,
    constants.WEDNESDAY_TEXT,
    constants.THURSDAY_TEXT,
    constants.FRIDAY_TEXT,
    constants.SATURDAY_TEXT,
    constants.SUNDAY_TEXT
];

export const weekDaysOptions = [
    { key: 0, text: constants.MONDAY_TEXT, value: 0 },
    { key: 1, text: constants.TUESDAY_TEXT, value: 1 },
    { key: 2, text: constants.WEDNESDAY_TEXT, value: 2 },
    { key: 3, text: constants.THURSDAY_TEXT, value: 3 },
    { key: 4, text: constants.FRIDAY_TEXT, value: 4 },
    { key: 5, text: constants.SATURDAY_TEXT, value: 5 },
    { key: 6, text: constants.SUNDAY_TEXT, value: 6 },
];

export const CONFIRMATION_MODE = Object.freeze({
    CONFIRMATION_MODE_ASYNCHRONOUS: "CONFIRMATION_MODE_ASYNCHRONOUS",
    CONFIRMATION_MODE_SYNCHRONOUS: "CONFIRMATION_MODE_SYNCHRONOUS",
});

export const RESERVATION_STATUS = Object.freeze({
    PENDING: "PENDING",
    CONFIRMED: "CONFIRMED",
    CANCELLED: "CANCELLED",
    ARCHIVED: "ARCHIVED",
});


// WEBPACK FOOTER //
// ./src/constants/reservations.js